// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StatsSimple_wrapper__35rAk","column":"StatsSimple_column__2hBO-","row":"StatsSimple_row__8DWaj"};